import { useDisconnect } from '@puzzlehq/sdk';
import { useNavigate } from '@tanstack/react-router';
import { Route as index_route } from '@src/routes/index.js';
import {
  HStack,
  Text,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogClose,
  DialogFooter,
  Button,
} from 'ui_2';
import { useSquashGameState } from '@src/providers/squashGameState';

const dAppNetwork: string = import.meta.env.VITE_NETWORK!;

export const IncorrectNetworkModal = () => {
  const { account } = useSquashGameState();
  const { disconnect, loading } = useDisconnect();
  const navigate = useNavigate();

  return (
    <Dialog
      open={
        account?.network !== undefined &&
        account.network.toString() !== dAppNetwork
      }
    >
      <DialogOverlay className='z-[1000]' />
      <DialogContent
        aria-describedby='network-description'
        className='z-[1000] w-4/5 max-w-[400px] rounded-[10px] border border-gray-100 bg-gray-50'
        showOverlay={false}
        showClose={false}
      >
        <DialogHeader>
          <DialogTitle className='text-center text-aqua'>
            <Text id='network-description'>
              Puzzle Wallet Network is incorrect!
            </Text>
          </DialogTitle>
          <DialogClose className='text-black' />
        </DialogHeader>
        <Text font='sm'>
          This dApp is only available on {dAppNetwork.replace('Aleo', '')}.
          Please switch the network in your wallet to continue playing.
        </Text>
        <Text font='sm'>
          If you just switched networks, this message will disappear shortly.
        </Text>
        <DialogFooter className='w-full'>
          <HStack className='w-full px-4'>
            <Button
              variant='gray'
              fullWidth
              disabled={loading}
              onClick={() =>
                disconnect().finally(() => navigate({ to: index_route.to }))
              }
            >
              Disconnect Wallet
            </Button>
          </HStack>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
